import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { noneStyle } from '../../../../helpers/common';
import { propShape, propStr } from '../../../../helpers/custom-prop-types';
const RawFileFieldComponent = (props) => {
    const inputRef = useRef(null);
    const { accept, className, input, label } = props;
    const wrapOnChange = useCallback((e) => {
        const values = Array.from(e.currentTarget.files);
        if (values.length > 0) {
            input.onBlur(values[0]);
        }
    }, [input]);
    const wrapOnClick = useCallback(() => {
        inputRef.current.click();
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("input", { accept: accept, onChange: wrapOnChange, ref: inputRef, style: noneStyle, type: 'file' }), _jsx("button", Object.assign({ className: className, onClick: wrapOnClick, type: 'button' }, { children: label })), input.value && (_jsxs("div", Object.assign({ className: 'selected-file-name' }, { children: [_jsx("i", Object.assign({ className: 'material-icons' }, { children: "insert_drive_file" })), _jsx("span", { children: input.value.name })] })))] }));
};
RawFileFieldComponent.propTypes = {
    accept: propStr().isRequired,
    className: propStr().isRequired,
    input: propShape().isRequired,
    label: propStr().isRequired,
};
export default RawFileFieldComponent;
